import BeautifulSkeleton from "./BeautifulSkeleton";

export const CardSkeleton = () => {
  return <BeautifulSkeleton variant="rect" />;
};
